/**
 * Role on Relationship
 */
export enum RoleOnRelationship {
  /**
   * Administrator
   */
  Administrator = 'administrator',

  /**
   * Contact
   */
  Contact = 'contact',
}
